'use client';

import { forwardRef, useContext } from 'react';

import { cx } from '@/styled-system/css';

import { Text } from '../text/text';
import { InlineFeedbackRootContext } from './context/inline-feedback-root.context';
import { inlineFeedbackLabelRecipe } from './styles/inline-feedback-label.styles';
import type { InlineFeedbackLabelPropsInterface } from './types/inline-feedback-label.types';

/**
 * @since 10.0.0
 */

export const InlineFeedbackLabel = forwardRef<HTMLSpanElement, InlineFeedbackLabelPropsInterface>(
  (props: InlineFeedbackLabelPropsInterface, forwardedRef) => {
    const inlineFeedbackRootContext = useContext(InlineFeedbackRootContext);
    const {
      tone = inlineFeedbackRootContext.tone || 'info',
      children,
      css: cssProp,
      ...rest
    } = props;

    return (
      <Text
        ref={forwardedRef}
        data-c11n-component="InlineFeedback.Label"
        data-c11n-version={__C11N_VERSION__}
        css={{
          ...inlineFeedbackLabelRecipe.raw({ tone }),
          ...cssProp,
        }}
        {...rest}
        className={cx('c11n_inline-feedback__label', rest.className)}
      >
        {children}
      </Text>
    );
  },
);

InlineFeedbackLabel.displayName = 'InlineFeedback.Label';
